import { ResetPasswordPage } from "@/pages/reset/password";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/reset/password/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <ResetPasswordPage />;
}
